<script>
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import { companyInfoMethods } from "@state/helpers";
import { required, email } from "vuelidate/lib/validators";
import { Chrome } from "vue-color";

var colors = {
  hex: "#194d33",
  a: 1,
};

export default {
  page: {
    title: "Administration/Company info",
    meta: [{ name: "Company-info", content: "Administration/Company info" }],
  },
  components: { Layout, PageHeader, "color-picker": Chrome },
  data() {
    return {
      title: "Administration/Company info",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Administration/Company info",
          active: true,
        },
      ],
      colors,
      action: "",
      createUpdateForm: {
        _id: "",
        company_name: "",
        primary_color: "",
        phone_number: "",
        whatsapp_number: "",
        contact_email: "",
        support_email: "",
        instagram_name: "",
        instagram_url: "",
        facebook_name: "",
        facebook_url: "",
      },
      isSubmitting: false,
      lightLogoLoader: false,
      darkLogoLoader: false,
      shortLightLogoLoader: false,
      shortDarkLogoLoader: false,
      showColorPicker: false,
    };
  },
  validations: {
    createUpdateForm: {
      company_name: {
        required,
      },
      primary_color: {},
      phone_number: {},
      whatsapp_number: {},
      contact_email: {
        required,
        email,
      },
      support_email: { email },
      instagram_name: {},
      instagram_url: {},
      facebook_name: {},
      facebook_url: {},
    },
  },
  mounted: function () {
    this.getCompanyInfo();
  },
  methods: {
    ...companyInfoMethods,

    onFormSubmit(evt) {
      evt.preventDefault();
      let context = this;
      context.isSubmitting = true;
      if (context.$v.createUpdateForm.$anyError) {
        context.$v.createUpdateForm.$touch();
      }
      let form = context.createUpdateForm;
      const promise = context.createUpdateCompanyInfo(form);
      return promise
        .then((data) => {
          this.$store.dispatch("appAuth/updateCompanyInfo", true);
          if (form._id) {
            context.$generate_toast(
              context,
              "success",
              context.$t("alerts.updated_successfully")
            );
          } else {
            context.$generate_toast(
              context,
              "success",
              context.$t("alerts.created_successfully")
            );
            this.getCompanyInfo();
          }
          context.isSubmitting = false;
          this.$store.dispatch("appAuth/updateCompanyInfo");
        })
        .catch((error) => {
          context.$axios_error_noty(error, context);
          context.isSubmitting = false;
        });
    },
    getCompanyInfo() {
      this.fetchCompanyInfo()
        .then((data) => {
          this.createUpdateForm._id = data._id;
          this.createUpdateForm.company_name = data.company_name;
          this.createUpdateForm.primary_color = data.primary_color;
          this.createUpdateForm.phone_number = data.phone_number;
          this.createUpdateForm.whatsapp_number = data.whatsapp_number;
          this.createUpdateForm.contact_email = data.contact_email;
          this.createUpdateForm.support_email = data.support_email;
          this.createUpdateForm.instagram_name = data.instagram_name;
          this.createUpdateForm.instagram_url = data.instagram_url;
          this.createUpdateForm.facebook_name = data.facebook_name;
          this.createUpdateForm.facebook_url = data.facebook_url;
          this.createUpdateForm.light_logo = data.light_logo;
          this.createUpdateForm.dark_logo = data.dark_logo;
          this.createUpdateForm.short_light_logo = data.short_light_logo;
          this.createUpdateForm.short_dark_logo = data.short_dark_logo;
          if (data.primary_color) {
            this.colors.hex = data.primary_color;
          }
        })
        .catch((error) => {
          this.$axios_error_noty(error, this);
        });
    },
    logoChanged(logoType, inputId, loaderVar) {
      // Available logo types ('light_logo', 'dark_logo', 'short_light_logo', 'short_dark_logo')
      let input = document.getElementById(inputId);
      if (input.files.length) {
        let context = this;
        context[loaderVar] = true;
        let logoFile = input.files[0];
        let formData = new FormData();
        formData.append("myfile", logoFile);
        formData.append("field", logoType);
        console.log("hola");
        context
          .setFileCompanyInfo(formData)
          .then((data) => {
            console.log("hola");
            this.$store.dispatch("appAuth/updateCompanyInfo", true);
            context.$generate_toast(
              context,
              "success",
              context.$t("alerts.updated_successfully")
            );
            context.createUpdateForm[logoType] = data[logoType];
            context[loaderVar] = false;
            this.$store.dispatch("appAuth/updateCompanyInfo");
          })
          .catch((error) => {
            context.$axios_error_noty(error, context);
            context[loaderVar] = false;
          });
      }
    },
    updateColor(cl) {
      if (cl) {
        this.createUpdateForm.primary_color = cl.hex;
      }
    },
  },
};
</script>
<style scoped>
.image-container {
  padding: 5px;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  margin: 5px 0px;
}
</style>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container fluid class="p-0">
      <b-row>
        <b-col sm="6" md="8" xs="12">
          <b-card>
            <h4 class="mb-3">{{ $t("company_info_section.basic_information") }}</h4>
            <b-form id="createUpdateForm" @submit="onFormSubmit">
              <form-wrapper :validator="$v.createUpdateForm">
                <div>
                  <form-summary />
                </div>
                <b-row>
                  <form-group
                    name="company_name"
                    :label="$t('company_info_section.company_name')"
                    class="col-md-6"
                  >
                    <b-form-input
                      v-model="createUpdateForm.company_name"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                    />
                  </form-group>
                  <form-group
                    name="primary_color"
                    :label="$t('company_info_section.primary_color')"
                    class="col-md-6"
                  >
                    <b-input-group>
                      <template v-if="createUpdateForm.primary_color" v-slot:prepend>
                        <span
                          :style="{
                            'background-color': createUpdateForm.primary_color,
                            width: '40px',
                          }"
                        >
                        </span>
                      </template>
                      <b-form-input
                        v-model="createUpdateForm.primary_color"
                        slot-scope="{ attrs, listeners }"
                        placeholder="Hexadecimal code of color"
                        v-bind="attrs"
                        v-on="listeners"
                        @click="showColorPicker = !showColorPicker"
                      />
                      <template v-slot:append>
                        <b-input-group-text
                          style="cursor: pointer"
                          @click="showColorPicker = !showColorPicker"
                        >
                          <span v-if="!showColorPicker"
                            >{{ $t("basic.show") }}
                            {{ $t("company_info_section.open_color_picker") }}</span
                          >
                          <span v-else
                            >{{ $t("basic.hide") }}
                            {{ $t("company_info_section.open_color_picker") }}</span
                          >
                        </b-input-group-text>
                      </template>
                    </b-input-group>
                  </form-group>
                  <color-picker
                    v-if="showColorPicker"
                    v-model="colors"
                    @input="updateColor"
                  />
                </b-row>
                <b-row>
                  <form-group
                    name="phone_number"
                    :label="$t('company_info_section.phone_number')"
                    class="col-md-6"
                  >
                    <b-form-input
                      v-model="createUpdateForm.phone_number"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                    />
                  </form-group>
                  <form-group
                    name="whatsapp_number"
                    :label="$t('company_info_section.whatsapp_number')"
                    class="col-md-6"
                  >
                    <b-form-input
                      v-model="createUpdateForm.whatsapp_number"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                    />
                  </form-group>
                </b-row>
                <b-row>
                  <form-group
                    name="contact_email"
                    :label="$t('company_info_section.contact_email')"
                    class="col-md-6"
                  >
                    <b-form-input
                      v-model="createUpdateForm.contact_email"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                    />
                  </form-group>
                  <form-group
                    name="support_email"
                    :label="$t('company_info_section.support_email')"
                    class="col-md-6"
                  >
                    <b-form-input
                      v-model="createUpdateForm.support_email"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                    />
                  </form-group>
                </b-row>
                <b-row>
                  <form-group
                    name="instagram_name"
                    :label="$t('company_info_section.instagram_name')"
                    class="col-md-6"
                  >
                    <b-form-input
                      v-model="createUpdateForm.instagram_name"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                    />
                  </form-group>
                  <form-group
                    name="instagram_url"
                    :label="$t('company_info_section.instagram_url')"
                    class="col-md-6"
                  >
                    <b-form-input
                      v-model="createUpdateForm.instagram_url"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                    />
                  </form-group>
                </b-row>
                <b-row>
                  <form-group
                    name="facebook_name"
                    :label="$t('company_info_section.facebook_name')"
                    class="col-md-6"
                  >
                    <b-form-input
                      v-model="createUpdateForm.facebook_name"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                    />
                  </form-group>
                  <form-group
                    name="facebook_url"
                    :label="$t('company_info_section.facebook_url')"
                    class="col-md-6"
                  >
                    <b-form-input
                      v-model="createUpdateForm.facebook_url"
                      slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                    />
                  </form-group>
                </b-row>
              </form-wrapper>
            </b-form>
            <b-button
              type="submit"
              form="createUpdateForm"
              size="sm"
              variant="primary"
              :disabled="$v.createUpdateForm.$invalid || isSubmitting"
            >
              <span v-if="!isSubmitting">
                {{ !!createUpdateForm._id ? $t("basic.update") : $t("basic.create") }}
              </span>
              <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
              </b-spinner>
            </b-button>
          </b-card>
        </b-col>
        <b-col v-if="createUpdateForm._id" md="4" sm="6" xs="12">
          <b-card>
            <h4 class="mb-3">Logos</h4>
            <b-form>
              <b-form-group
                id="input-group-image"
                label="Main logo (height: 80px)"
                label-for="input-images"
              >
                <div v-if="createUpdateForm.light_logo" class="image-container">
                  <b-img
                    :src="createUpdateForm.light_logo.url"
                    fluid
                    alt="light-logo"
                  ></b-img>
                </div>
                <b-form-file
                  id="light_logo"
                  placeholder="Upload image"
                  drop-placeholder="Drop file here..."
                  :browse-text="lightLogoLoader ? 'Sending...' : 'Browse'"
                  :disabled="lightLogoLoader"
                  @change="logoChanged('light_logo', 'light_logo', 'lightLogoLoader')"
                >
                </b-form-file>
              </b-form-group>
              <b-form-group
                id="input-group-image"
                label="Short logo (50x50)"
                label-for="input-images"
              >
                <div v-if="createUpdateForm.short_light_logo" class="image-container">
                  <b-img
                    :src="createUpdateForm.short_light_logo.url"
                    fluid
                    alt="short-light-logo"
                  ></b-img>
                </div>
                <b-form-file
                  id="short_light_logo"
                  placeholder="Upload image"
                  drop-placeholder="Drop file here..."
                  :browse-text="shortLightLogoLoader ? 'Sending...' : 'Browse'"
                  :disabled="shortLightLogoLoader"
                  @change="
                    logoChanged(
                      'short_light_logo',
                      'short_light_logo',
                      'shortLightLogoLoader'
                    )
                  "
                >
                </b-form-file>
              </b-form-group>
              <b-form-group
                id="input-group-image"
                label="Dark logo (height: 80px)"
                label-for="input-images"
              >
                <div v-if="createUpdateForm.dark_logo" class="image-container">
                  <b-img
                    :src="createUpdateForm.dark_logo.url"
                    fluid
                    alt="dark-logo"
                  ></b-img>
                </div>
                <b-form-file
                  id="dark_logo"
                  placeholder="Upload image"
                  drop-placeholder="Drop file here..."
                  :browse-text="darkLogoLoader ? 'Sending...' : 'Browse'"
                  :disabled="darkLogoLoader"
                  @change="logoChanged('dark_logo', 'dark_logo', 'darkLogoLoader')"
                >
                </b-form-file>
              </b-form-group>
              <b-form-group
                id="input-group-image"
                label="Short dark (50x50)"
                label-for="input-images"
              >
                <div v-if="createUpdateForm.short_dark_logo" class="image-container">
                  <b-img
                    :src="createUpdateForm.short_dark_logo.url"
                    fluid
                    alt="short-dark-logo"
                  ></b-img>
                </div>
                <b-form-file
                  id="short_dark_logo"
                  placeholder="Upload image"
                  drop-placeholder="Drop file here..."
                  :browse-text="shortDarkLogoLoader ? 'Sending...' : 'Browse'"
                  :disabled="shortDarkLogoLoader"
                  @change="
                    logoChanged(
                      'short_dark_logo',
                      'short_dark_logo',
                      'shortDarkLogoLoader'
                    )
                  "
                >
                </b-form-file>
              </b-form-group>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </Layout>
</template>
